const GroupCategoryQueryKeys = {
  global: ["groupCategories"] as const,
  list: () => [...GroupCategoryQueryKeys.global, "list"] as const,
  details: (id: string) =>
    [...GroupCategoryQueryKeys.global, "details", id] as const,
};

export { GroupCategoryQueryKeys };
